<template lang="html">
  <div class="product-item" @click="productClicked">
    <div class="product-inner buider-mode">
      <div class="product-image" :style="backgroundImage"></div>
      <div class="product-name text-truncate">
        {{ wardrobeProduct.product.brand_name }}
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  props: {
    wardrobeProduct: {
      type: Object,
      required: true
    }
  },

  methods: {
    productClicked() {
      const payload = {
        productId: this.wardrobeProduct.product.id
      }

      bus.$emit("submitAddCapsuleLayerProduct", payload);
    }
  },

  computed: {
    backgroundImage() {
      return 'background-image: url("' + this.wardrobeProduct.product.featured_image + '")';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_product-item.scss";
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/modals/addProductModal/Product.vue